import React, { useState } from 'react';

// --- (SVG Icons remain the same) ---
const LinkedinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-4.484 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.594-11.018-3.714v-2.155z" />
  </svg>
);
const MailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-21.518 14v-11.817l10 8.104 10-8.104v11.817h-20z" />
  </svg>
);
const RupeeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M19 6h-6.59l2.12-2.12-.71-.71-2.83 2.83-2.83-2.83-.71.71 2.12 2.12h-1.59v2h-2v2h2v2h-2v2h2v2h-3v2h11v-2h-5v-2h5v-2h-5v-2h5v-2h-5v-2h6.59l-2.12 2.12.71.71 2.83-2.83 2.83 2.83.71-.71-2.12-2.12h1.59v-2h2v-2h-2v-2z" />
  </svg>
);

const People = ({ person }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const fullDescription = `${person.about} ${person.why_joined}`;
  const shortDescription = person.about.slice(0, 180) + '...';

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    // 👇 The change is on this line: md:max-w-4xl is now md:max-w-2xl
    <div className="max-w-sm w-full mx-auto bg-white rounded-2xl shadow-lg overflow-hidden md:max-w-2xl hover:shadow-2xl transition-shadow duration-300">
      <div className="md:flex">
        <div className="md:flex-shrink-0 relative">
          <img
            className="h-64 w-full object-cover object-top md:h-full md:w-64"
            src={person.img}
            alt={`Profile of ${person.name}`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
          <div className="absolute bottom-4 left-4 text-white">
            <h2 className="text-2xl font-bold">{person.name}</h2>
            <p className="text-md font-light">{person.job}</p>
          </div>
        </div>
        <div className="p-8 flex flex-col justify-between">
          <div>
            <p className="mt-2 text-gray-600 text-base leading-relaxed">
              {isExpanded ? fullDescription : shortDescription}
            </p>
            <button
              onClick={toggleExpansion}
              className="text-indigo-500 hover:text-indigo-700 font-semibold mt-4 focus:outline-none"
            >
              {isExpanded ? 'Read less' : 'Read more'}
            </button>
          </div>
          <div className="mt-6">
            <h3 className="text-gray-700 font-semibold mb-2">Contact</h3>
            <div className="flex items-center space-x-4">
              <a
                href={person.linkdin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-gray-900 transition-colors duration-200"
              >
                <span className="sr-only">LinkedIn</span>
                <LinkedinIcon />
              </a>
              <a
                href={`mailto:${person.mail}`}
                className="text-gray-500 hover:text-gray-900 transition-colors duration-200"
              >
                <span className="sr-only">Email</span>
                <MailIcon />
              </a>
              <div className="relative group">
                <a
                  href={`upi://pay?pa=${person.upi}&pn=${person.name}&cu=INR`}
                  className="text-gray-500 hover:text-gray-900 transition-colors duration-200"
                >
                  <span className="sr-only">UPI</span>
                  <RupeeIcon />
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-max bg-gray-800 text-white text-xs rounded py-1 px-2">
                  {person.upi}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default People;
